// No queue of user intentions: a delayed second click must not become a new call.
export class CallControl {
  private occupied = false;
  get busy() { return this.occupied; }
  async run<T>(operation: () => Promise<T>): Promise<T> {
    if (this.occupied) throw Object.assign(new Error("Предыдущее действие со звонком ещё выполняется"), { code: "CALL_CONTROL_BUSY" });
    this.occupied = true;
    try { return await operation(); }
    finally { this.occupied = false; }
  }
}
